if (process.env.BUILD_FLAVOUR === 'free') {
    require('./TwoColumn');
    require('./ThreeColumn');
    require('./button');
    require('./TwoColumn');
} else {
    require('./Title');
    require('./WYSIWYG');
    require('./Image');
    require('./Divider');
    require('./Button');
    require('./Shortcode');
    require('./SocialIcons');
    require('./SingleColumn');
    require('./TwoColumn');
    require('./ThreeColumn');
    require('./FourColumn');
    require('./ThirtySeventy');
    require('./SeventyThirty');
    require('./Twenty5FiftyTwenty5');
}
